/**
 * <buy-buttons> — keeps the Add to cart label in sync with the server-rendered state.
 * product-info.js does not swap #ProductSubmitButton-{id}; it only reads its `disabled`
 * attribute and lets product-form.js relabel the first <span> ("Add to cart" / "Sold out").
 * On PUB_SUB_EVENTS.variantChange (payload carries the fetched section `html`) we copy:
 *  - the label text (pre-order label, sold out, unavailable),
 *  - the "· $price" span,
 *  - the Notify-me wrapper (inline back-in-stock form, or the dialog button, for sold-out variants).
 * product-form.js keeps its cached references because the nodes themselves are not replaced.
 */
if (!customElements.get('buy-buttons')) {
  customElements.define(
    'buy-buttons',
    class BuyButtons extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        if (typeof subscribe !== 'function' || !window.PUB_SUB_EVENTS) return;
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (!data || data.sectionId !== this.sectionId || !data.html) return;
          this.sync(data.html);
        });
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }

      sync(html) {
        const source = html.getElementById(`ProductSubmitButton-${this.sectionId}`);
        const button = this.querySelector(`#ProductSubmitButton-${this.sectionId}`);

        if (source && button) {
          const label = button.querySelector('span');
          const sourceLabel = source.querySelector('span');
          if (label && sourceLabel) label.textContent = sourceLabel.textContent.trim();

          const price = button.querySelector('[data-price]');
          const sourcePrice = source.querySelector('[data-price]');
          if (price && sourcePrice) {
            price.textContent = sourcePrice.textContent.trim();
            price.setAttribute('aria-hidden', sourcePrice.getAttribute('aria-hidden') || 'false');
          }
        }

        const notify = this.querySelector(`#NotifyMeWrapper-${this.sectionId}`);
        const sourceNotify = html.getElementById(`NotifyMeWrapper-${this.sectionId}`);
        if (notify && sourceNotify) {
          // Inline form: keep an email the visitor already typed when they switch size.
          const typed = notify.querySelector('input[type="email"]')?.value || '';
          notify.innerHTML = sourceNotify.innerHTML;
          const fresh = notify.querySelector('input[type="email"]');
          if (fresh && typed) fresh.value = typed;
        }
      }
    }
  );
}
